import { EBTTriggerTypeOptionsValue, GeofenceEntityType } from './enums';
import { AssetState } from './Events/Messages';
import { AssetCoordinatesDwell, AssetCoordinatesTriggered } from './Events/schema';

export const isDwellEvent = (event: AssetCoordinatesDwell | AssetCoordinatesTriggered) => {
  return 'dwellSeconds' in event;
};

export const getEventDescription = (event: AssetCoordinatesTriggered | AssetCoordinatesDwell) => {
  return 'entered' in event
    ? event.fenceIds.type === GeofenceEntityType.Line
      ? event.entered
        ? EBTTriggerTypeOptionsValue.LeftToRight
        : EBTTriggerTypeOptionsValue.RightToLeft
      : event.entered
      ? EBTTriggerTypeOptionsValue.Entry
      : EBTTriggerTypeOptionsValue.Exit
    : EBTTriggerTypeOptionsValue.Dwell;
};

export const createGeofenceEventUniqueIdentifier = (
  event: AssetCoordinatesDwell | AssetCoordinatesTriggered,
) => {
  const eventDescription = getEventDescription(event);
  return JSON.stringify({
    assetId: event.ids.id,
    iso8601: event.iso8601,
    order: event.order,
    fenceId: event.fenceIds.id,
    coordinates: event.coordinates,
    eventDescription,
    isMobileEvent: event.isMobileEvent,
  });
};

export const setSelectRecentFenceEvent = (
  stringifiedEventData: string | undefined,
  assetState: AssetState,
): AssetState => {
  const recentFenceEvents: (AssetCoordinatesTriggered | AssetCoordinatesDwell)[] | undefined =
    assetState.recentFenceEvents?.map(recentFenceEvent => {
      return {
        ...recentFenceEvent,
        selected:
          stringifiedEventData && stringifiedEventData === recentFenceEvent.uniqueIdentifier,
      } as AssetCoordinatesTriggered | AssetCoordinatesDwell;
    });
  return {
    ...assetState,
    recentFenceEvents,
  };
};

export const uniqueIdentifierIsValid = (uniqueIdentifier: string): boolean => {
  try {
    const unstringifiedUniqueIdentifier = JSON.parse(uniqueIdentifier);
    return (
      'assetId' in unstringifiedUniqueIdentifier &&
      'iso8601' in unstringifiedUniqueIdentifier &&
      'order' in unstringifiedUniqueIdentifier &&
      'fenceId' in unstringifiedUniqueIdentifier &&
      'eventDescription' in unstringifiedUniqueIdentifier &&
      'isMobileEvent' in unstringifiedUniqueIdentifier
    );
  } catch {
    return false;
  }
};
